import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api.js';
import { t } from '../i18n.js';
import ModuleKaarten from './ModuleKaarten.jsx';

/**
 * Beheer › Klanten › Modules (docs/besluiten/modules-per-klant.md): afnemen met de hand, tot ADTS-ONE de contractregels
 * levert, en aan- of uitzetten. Uit: geen nieuwe alerts uit die module bij deze klant; wat er al is, blijft.
 */
export default function KlantModules({ klant, onSluit }) {
  const q = useQuery({ queryKey: ['klant-modules', klant.code], queryFn: () => api.klantModules(klant.code) });
  const [melding, zetMelding] = useState(null);
  const [bezig, zetBezig] = useState(false);
  const doe = (fn) => async (...args) => {
    zetMelding(null); zetBezig(true);
    try { await fn(...args); } catch (e) { zetMelding(t(e.message)); } finally { zetBezig(false); q.refetch(); }
  };
  return (
    <section className={onSluit ? 'card' : undefined} style={onSluit ? { marginTop: 14 } : undefined}>
      {onSluit && <header><h2>{t('Modules van {klant}', { klant: klant.name })}</h2>
        <span className="meta"><Link to={`/meekijken/${klant.code}/modules`}>{t('Meekijken als klant')}</Link>{' · '}
          <button type="button" className="namelink" onClick={onSluit}>{t('Sluiten')}</button></span></header>}
      {melding && <div className="melder rood" style={{ marginBottom: 10 }}>{melding}</div>}
      {q.isPending ? <p className="muted">{t('Laden…')}</p> : q.isError ? <div className="melder rood">{t(q.error.message)}</div> : (
        <ModuleKaarten modules={q.data.data.modules} bezig={bezig} ookOningericht doe={{
          afnemen: doe((id, afgenomen) => api.zetKlantModule(klant.code, id, { afgenomen })),
          schakel: doe((id, aan) => api.zetKlantModule(klant.code, id, { aan })),
        }} />
      )}
      <p className="noot" style={{ marginTop: 10 }}>{t('Afnemen gaat nu met de hand; straks komt het uit de contractregels in ADTS-ONE. Een klant-beheerder kan een afgenomen module ook zelf aan- en uitzetten.')}</p>
    </section>
  );
}
